// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wl_a bhy_b"};